import getDistance from "levenshtein-lite";

import supportedEmailClients from "../../constants/supportedDomains";

const querySuggestedEmail = (testEmail = "") => {
  const [testPrefix, testDomain] = testEmail.split("@");

  if (!testPrefix || !testDomain) {
    return "";
  }

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < supportedEmailClients.length; i++) {
    const supportedDomain = supportedEmailClients[i];
    /**
     * If the domain provided by the user matches a supported domain, we don't
     * need to try to determine if it is some distance from another supported domain.
     * Ex. if the user enters an @gmail.com address, we shouldn't recommend
     * an @ymail address.
     */
    if (testDomain === supportedDomain) {
      return "";
    }

    const distanceToClient = getDistance(testDomain, supportedDomain);

    if (distanceToClient > 0 && distanceToClient <= 2) {
      return `${testPrefix}@${supportedDomain}`;
    }
  }

  return "";
};

export default querySuggestedEmail;
